import { useState, useEffect } from "react";
import axiosInstance from "../utils/axiosSetup";


const usePermissionChecker = () => {
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    axiosInstance.get(`${process.env.REACT_APP_API_URL}/get_employee_permissions?employees=true`)
    .then(response => {
        setPermissions(response.data.data);
    })
    .catch(error => {
        setPermissions([]);
    });
  }, []);


  const checkPermission = (permission) => {
      const isMatch = permissions.find((element) => {
        return element.toLowerCase() === permission.toLowerCase();
      });
      return isMatch ? true: false;
  };

  return { checkPermission };
};

export default usePermissionChecker;